module.exports = __webpack_public_path__ + "images/avisbudget_smallef67c939645389599436815d35b9abec.png";